"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REACT_PIVATE_PROPS = void 0;
exports.REACT_PIVATE_PROPS = ['children', 'hooks', 'ref'];
exports.default = {};
//# sourceMappingURL=constant.js.map